import { ref, reactive, watch } from 'vue';
import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5eacd9ac"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "over-sea-content"
};
const _hoisted_2 = {
  class: "flex-content"
};
const __default__ = {
  name: 'Google'
};
export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    rules: {},
    detailForm: {}
  },
  emits: ['submitForm', 'setVisible'],
  setup(__props, {
    expose,
    emit
  }) {
    const props = __props;
    const divideList2 = ref([]); // 分成比例
    const vivoRef = ref(null); // VIVOref
    const vivoForm = reactive({
      divide: '0.5',
      pkg: '',
      appId: '',
      appKey: '',
      id: ''
    }); // VIVO
    const validateForm = () => {
      var _vivoRef$value;
      (_vivoRef$value = vivoRef.value) === null || _vivoRef$value === void 0 || _vivoRef$value.validate().then(() => {
        emit('submitForm', vivoForm);
      }).catch(e => void 0);
    };
    watch(() => props.detailForm, n => {
      if (n) {
        vivoForm.pkg = n.pkg;
        vivoForm.id = n.id;
        vivoForm.appId = n.appId;
        vivoForm.cpId = n.cpId;
        vivoForm.appKey = n.appKey;
        divideList2.value = n.rateList;
        vivoForm.divide = n.divide;
      }
    }, {
      immediate: true,
      deep: true
    });
    expose({
      validateForm
    });
    return (_ctx, _cache) => {
      const _component_a_input = _resolveComponent("a-input");
      const _component_a_form_item = _resolveComponent("a-form-item");
      const _component_a_select = _resolveComponent("a-select");
      const _component_a_form = _resolveComponent("a-form");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_a_form, {
        model: vivoForm,
        ref_key: "vivoRef",
        ref: vivoRef,
        rules: __props.rules,
        name: "gp-validate"
      }, {
        default: _withCtx(() => [_createVNode(_component_a_form_item, {
          name: "pkg",
          label: "包名："
        }, {
          default: _withCtx(() => [_createVNode(_component_a_input, {
            value: vivoForm.pkg,
            "onUpdate:value": _cache[0] || (_cache[0] = $event => vivoForm.pkg = $event),
            valueModifiers: {
              trim: true
            },
            disabled: ""
          }, null, 8, ["value"])]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          name: "appId",
          label: "APPID: "
        }, {
          default: _withCtx(() => [_createVNode(_component_a_input, {
            value: vivoForm.appId,
            "onUpdate:value": _cache[1] || (_cache[1] = $event => vivoForm.appId = $event),
            valueModifiers: {
              trim: true
            },
            disabled: ""
          }, null, 8, ["value"])]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          name: "appKey",
          label: "APPKEY: "
        }, {
          default: _withCtx(() => [_createVNode(_component_a_input, {
            value: vivoForm.appKey,
            "onUpdate:value": _cache[2] || (_cache[2] = $event => vivoForm.appKey = $event),
            valueModifiers: {
              trim: true
            },
            disabled: ""
          }, null, 8, ["value"])]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          name: "cpId",
          label: "CPID: "
        }, {
          default: _withCtx(() => [_createVNode(_component_a_input, {
            value: vivoForm.cpId,
            "onUpdate:value": _cache[3] || (_cache[3] = $event => vivoForm.cpId = $event),
            valueModifiers: {
              trim: true
            },
            disabled: ""
          }, null, 8, ["value"])]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          name: "divide",
          label: "分成系数：",
          help: "结算收入=总订单金额*(1-5%)*50%,其中5%为支付通道费费率;"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_a_select, {
            value: vivoForm.divide,
            "onUpdate:value": _cache[4] || (_cache[4] = $event => vivoForm.divide = $event),
            options: divideList2.value
          }, null, 8, ["value", "options"])])]),
          _: 1
        })]),
        _: 1
      }, 8, ["model", "rules"])]);
    };
  }
});